import { gql } from "@apollo/client";

const schema = {
  request: {
    name: "request",
    serviceName: "auth",
    query: gql`
      query request($limit: Int, $status: String) {
        request(limit: $limit, status: $status) {
          total
          data {
            type
            details
          }
        }
      }
    `,
  },
};

export default schema;
